import Loader from "Components/Loading/Loader/Loader";
import ChecklistTemplatePageConstants from "Constants/ChecklistTemplatePageConstants";
import { ChecklistTemplate } from "Models/Checklists/ChecklistTemplate";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import * as React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IChecklistTemplateAction } from "Store/ChecklistTemplates/ChecklistTemplateAction";
import { ChecklistTemplateFilterState } from "Store/ChecklistTemplates/ChecklistTemplateFilterState";
import { IApplicationState } from "Store/Store";
import i18n from "Translations/i18n";
import ChecklistTemplateBlockCard from "./ChecklistTemplateBlockCard/ChecklistTemplateBlockCard";
import styles from "./ChecklistTemplateBlockView.scss";

const checklistTemplateAction = ServiceProvider.get<IChecklistTemplateAction>(Types.IChecklistTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getChecklistTemplatesByFilterAsync: (filter: TemplateFilter) =>
        dispatch(checklistTemplateAction.getChecklistTemplatesByFilterAsync(filter)),
});

const mapStateToProps = (state: IApplicationState) => ({
    isLoading: state.checklistTemplateState.isLoading,
    totalChecklists: state.checklistTemplateState.totalChecklists,
    checklistTemplates: state.checklistTemplateState.checklistTemplates,
    currentFilter: state.checklistTemplateState.currentFilter,
    skip: (state.checklistTemplateState.currentFilter && state.checklistTemplateState.currentFilter.skip) || 0
});

interface IProps {
    isLoading: boolean;
    totalChecklists?: number;
    checklistTemplates?: ChecklistTemplate[];
    currentFilter: ChecklistTemplateFilterState;
    skip: number;
    getChecklistTemplatesByFilterAsync: (filter: TemplateFilter) => Action;
}

export class ChecklistTemplateBlockView extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.loadMore = this.loadMore.bind(this);
    }

    public componentDidMount() {
        this.loadChecklistTemplates(0);
    }

    private loadChecklistTemplates(skip: number) {
        const filter = {
            ...this.props.currentFilter,
            skip,
            take: ChecklistTemplatePageConstants.BLOCK_ITEMS_PER_PAGE
        };
        this.props.getChecklistTemplatesByFilterAsync(filter);
    }

    public loadMore() {
        if (!this.props.isLoading) {
            const skip = this.props.skip;
            const totalChecklists = this.props.totalChecklists;
            const itemsOnPage = this.props.checklistTemplates!.length;

            if (skip + ChecklistTemplatePageConstants.BLOCK_ITEMS_PER_PAGE < totalChecklists! && skip < itemsOnPage) {
                const newSkip = skip + ChecklistTemplatePageConstants.BLOCK_ITEMS_PER_PAGE;

                if (newSkip !== skip) {
                    this.loadChecklistTemplates(newSkip);
                }
            }
        }
    }

    public render() {
        return (
            <div className={styles.checklistTemplateBlockView}>
                {
                    (this.props && this.props.checklistTemplates && this.props.totalChecklists) ? (
                        <InfiniteScroll
                            id="infiniteScroll"
                            pageStart={0}
                            loadMore={this.loadMore}
                            hasMore={this.props.totalChecklists > this.props.checklistTemplates.length}
                            loader={<div className="loader" key={0}>Loading ...</div>}>
                            <div className={styles.overviewHeader}>
                                <div className={styles.numResults}>{this.props.totalChecklists} results</div>
                            </div>
                            <div className={styles.list}>
                                {this.props.checklistTemplates.map(checklistTemplate => <ChecklistTemplateBlockCard key={checklistTemplate.id} checklistTemplate={checklistTemplate} />)}
                            </div>
                        </InfiniteScroll>
                    ) : (this.props.isLoading) ? (<Loader />) : (<span>{i18n.t("checklists.noChecklistsFound")}</span>)
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistTemplateBlockView);


// WEBPACK FOOTER //
// ./src/Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateBlockView/ChecklistTemplateBlockView.tsx